(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // mouseenter/leave don't bubble: listen in capture phase so cards rendered later are covered too.
  const toggleHoverVideo = (event, play) => {
    if (!(event.target instanceof Element) || !event.target.matches('.card-gallery')) return;
    const video = event.target.querySelector('.card-gallery__hover-video');
    if (!(video instanceof HTMLVideoElement)) return;
    if (play) {
      video.play().catch(() => {});
    } else {
      video.pause();
      video.currentTime = 0;
    }
  };
  document.addEventListener('mouseenter', (event) => toggleHoverVideo(event, true), true);
  document.addEventListener('mouseleave', (event) => toggleHoverVideo(event, false), true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('text-read-more')) {
    class TextReadMore extends HTMLElement {
      #controller = new AbortController();

      #resizeObserver;

      #animation;

      #expanded = false;

      get #content() {
        return this.querySelector('[data-read-more-content]');
      }

      get #button() {
        return this.querySelector('[data-read-more-toggle]');
      }

      get #collapsedHeight() {
        const collapsedHeight = Number(this.dataset.collapsedHeight);

        return Number.isFinite(collapsedHeight) && collapsedHeight > 0 ? collapsedHeight : 160;
      }

      connectedCallback() {
        const content = this.#content;
        const button = this.#button;

        if (!(content instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) return;

        const { signal } = this.#controller;

        button.addEventListener('click', this.#toggle, { signal });

        this.#resizeObserver = new ResizeObserver(() => this.#syncOverflowState());
        this.#resizeObserver.observe(content);

        requestAnimationFrame(() => this.#syncOverflowState());

        document.fonts?.ready?.then(() => {
          if (this.isConnected) this.#syncOverflowState();
        });
      }

      disconnectedCallback() {
        this.#controller.abort();
        this.#animation?.cancel();
        this.#resizeObserver?.disconnect();
      }

      #syncOverflowState = () => {
        const content = this.#content;
        const button = this.#button;

        if (!(content instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) return;
        if (this.#animation) return;

        const isOverflowing = content.scrollHeight - 1 > this.#collapsedHeight;

        content.dataset.readMoreReady = isOverflowing ? 'true' : 'false';
        button.hidden = !isOverflowing;

        if (!isOverflowing) {
          this.#expanded = false;
          this.dataset.expanded = 'false';
          button.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-collapsed');
          content.style.removeProperty('height');
          content.style.removeProperty('overflow');
          return;
        }

        this.style.setProperty('--text-read-more-collapsed-height', `${this.#collapsedHeight}px`);

        if (this.#expanded) {
          this.dataset.expanded = 'true';
          button.setAttribute('aria-expanded', 'true');
          content.classList.remove('is-collapsed');
        } else {
          this.dataset.expanded = 'false';
          button.setAttribute('aria-expanded', 'false');
          content.classList.add('is-collapsed');
        }
      };

      #toggle = () => {
        if (this.#animation) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.#expanded = !this.#expanded;
          this.#syncOverflowState();
          return;
        }

        if (this.#expanded) {
          this.#collapse();
        } else {
          this.#expand();
        }
      };

      #expand() {
        const content = this.#content;

        if (!(content instanceof HTMLElement)) return;

        const startHeight = content.offsetHeight;

        content.style.height = `${startHeight}px`;
        content.style.overflow = 'hidden';
        content.classList.remove('is-collapsed');

        const endHeight = content.scrollHeight;

        this.#animate(startHeight, endHeight, true);
      }

      #collapse() {
        const content = this.#content;

        if (!(content instanceof HTMLElement)) return;

        const startHeight = content.offsetHeight;

        content.style.height = `${startHeight}px`;
        content.style.overflow = 'hidden';

        this.#animate(startHeight, this.#collapsedHeight, false);
      }

      #animate(startHeight, endHeight, expand) {
        const content = this.#content;
        const button = this.#button;

        if (!(content instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) return;

        button.disabled = true;

        this.#animation = content.animate(
          {
            height: [`${startHeight}px`, `${endHeight}px`],
          },
          {
            duration: 300,
            easing: 'ease',
          }
        );

        this.#animation.onfinish = () => {
          this.#expanded = expand;
          this.dataset.expanded = expand ? 'true' : 'false';
          button.setAttribute('aria-expanded', expand ? 'true' : 'false');
          button.disabled = false;
          content.classList.toggle('is-collapsed', !expand);
          content.style.removeProperty('height');
          content.style.removeProperty('overflow');
          this.#animation = undefined;
        };

        this.#animation.oncancel = () => {
          button.disabled = false;
          this.#animation = undefined;
        };
      }
    }

    customElements.define('text-read-more', TextReadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
